import * as z from "zod";

export const getShipmentVolumeByPackage = {
  name: "getShipmentVolumeByPackage" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    packages: z.array(
      z.object({
        packageId: z.string().nullable(),
        packageName: z.string(),
        shipmentCount: z.number(),
      }),
    ),
  }),
};
